import script from "./showIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./showIndex.vue?vue&type=script&setup=true&lang=js"

import "./showIndex.vue?vue&type=style&index=0&id=6ca85dab&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca85dab"]])

export default __exports__